'use strict';

var React = require('react');
var reactIcons = require('@sravni/react-icons');
var reactUtils = require('@sravni/react-utils');
var sizes = require('../../../constants/sizes.js');
var Icon = require('../../Icon/src/Icon.js');
var Tag_module = require('../styles/Tag.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Tag for categorizing or markup
 *
 * @component
 * @example
 * ```jsx
 * <Tag>content</Tag>
 * ```
 */
const Tag = React__namespace.forwardRef((props, ref) => {
    const { size, active, closable, onClose, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Tag_module.default);
    const classNames = cx(className, 'container', {
        active,
        [`size-${size}`]: size,
    });
    return (React__namespace.createElement("span", { ref: ref, "data-qa": "Tag", className: classNames, ...restProps },
        children,
        closable ? React__namespace.createElement(Icon.Icon, { icon: React__namespace.createElement(reactIcons.Cross, null), onClick: onClose }) : null));
});
Tag.defaultProps = {
    size: sizes.CONTAINER_SIZES.S44,
};
Tag.displayName = 'Tag';

exports.Tag = Tag;
//# sourceMappingURL=Tag.js.map
